export default __webpack_public_path__ + "static/media/CardBlank.73ece039.png";